import { commonParser } from './apiParser.helpers'

const formatUGCData = (data) => {
  const tweetMap = new Map()
  data.forEach((record) => {
    const { postId, interaction, amountReceived, insertedAt } =
      commonParser(record)
    if (!tweetMap.has(postId)) {
      tweetMap.set(postId, {
        postId,
        insertedAt: new Date(insertedAt),
        interactions: { comment: 0, like: 0, reply: 0 },
        totalReward: 0
      })
    }
    const tweet = tweetMap.get(postId)
    tweet.interactions[interaction] = tweet.interactions[interaction] + 1
    tweet.totalReward += amountReceived
    const currentInserted = new Date(insertedAt)
    if (currentInserted > tweet.insertedAt) {
      tweet.insertedAt = currentInserted
    }
  })
  const uniqueTweets = Array.from(tweetMap.values()).sort((a, b) => {
    return b.insertedAt - a.insertedAt
  })
  return uniqueTweets.slice(0, 5)
}

const postXMessageUrl = () => {
  return 'https://x.com/intent/post?text=Proud%20to%20be%20part%20of%20the%20QBX%20VIP%20Club%20%40qiibeefdn%20%E2%80%94%20where%20loyalty%20actually%20pays%20off.%0AStaking%20%24QBX%20%3D%20daily%20rewards%2C%20exclusive%20perks%2C%20and%20much%20more.%20%F0%9F%8E%81%0AEarn%20while%20you%20hold.%20Grow%20while%20you%20chill.'
}

export { formatUGCData, postXMessageUrl }
